<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/questions" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 secondary--text headline">Question {{questionData.id}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex v-if="found" class="text-xs-center" xs12>
      <v-tabs class="pa-0 ma-0" v-model="manageTab" color="transparent" slider-color="accent" centered>
        <v-tab ripple>Preview</v-tab>
        <v-tab ripple>Edit</v-tab>
        <v-tab-item>
          <r-question-preview :question-data="questionData"></r-question-preview>
        </v-tab-item>
        <v-tab-item>
          <r-edit-question @updated="loadQuestion" :question-data="questionData"></r-edit-question>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import QuestionPreview from './QuestionPreview.vue'
import EditQuestion from './EditQuestion.vue'
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rQuestionPreview: QuestionPreview,
    rEditQuestion: EditQuestion,
    rCrumbs: Crumbs
  },
  data: () => ({
    found: false,
    manageTab: '0',
    questionData: {}
  }),
  created () {
    this.beforeEnter()
  },
  beforeMount () {
    this.loadQuestion()
  },
  methods: {
    loadQuestion () {
      const q = {...this.$store.getters.questionData(+this.$route.params.id)}
      this.questionData = {
        ...q,
        tags: q.tags ? [...q.tags] : [],
        area: q.area ? [...q.area] : [],
        answers: q.answers ? [...q.answers] : []
      }
    },
    beforeEnter () {
      const params = this.$route.params
      const url = +params.id
      if (this.$store.getters.questionData(url)) this.found = true
      else {
        const appMsg = {
          type: 'error',
          msg: 'Question not found'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/questions')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/ManageQuestion.vue